import Cookies from "js-cookie"
import { ACCESS_TOKEN } from "../../util/constants/APP_RESERVED_NAME"
import { API_HEADER } from "../../util/constants/HEADERS"

export function getUserPoints () {
    const user_json = JSON.parse(localStorage.getItem('asg_user') ?? '{}')

    return fetch(`${process.env.REACT_APP_API_URL}userInteraction/getPoints/${user_json.id}`, {
        method: 'POST',
        headers: {
            ...API_HEADER,                
            Authorization: `Bearer ${Cookies.get(ACCESS_TOKEN)}`
        },
    })
    .then(res => res.json())
    .then(res => ({
        ...res,
        points: (res.points || 0).toString().padStart(2, '0')
    }))
   
}